import { render, staticRenderFns } from "./UiChips.vue?vue&type=template&id=ce9eb96a"
import script from "./UiChips.vue?vue&type=script&lang=js"
export * from "./UiChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports